// FIXME: Stripeでの通貨表記に合わせるための機能(V4対応で追加)
//  - (背景) 価格表記をStripeでの表記に合わせたいという要望があった
//  - CLIPサービスでの価格表記が統一されたらそれに合わせる。(それまではこのまま)
export default new (class StripePrice {
  getPrice(currencyCode: string, price: number) {
    if (currencyCode === "JPY") {
      return "￥" + Intl.NumberFormat("ja-JP").format(price);
    }
    if (currencyCode === "USD") {
      return (
        "$" +
        Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(price)
      );
    }
    if (currencyCode === "EUR") {
      return (
        "€" +
        Intl.NumberFormat("fr-FR", { minimumFractionDigits: 2 }).format(price)
      );
    }
    if (currencyCode === "HKD") {
      return (
        "HK$" +
        Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(price)
      );
    }
    if (currencyCode === "GBP") {
      return (
        "£" +
        Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(price)
      );
    }
    if (currencyCode === "CAD") {
      return (
        "CA$" +
        Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(price)
      );
    }
    if (currencyCode === "AUD") {
      return (
        "A$" +
        Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(price)
      );
    }
    if (currencyCode === "KRW") {
      return "₩" + Intl.NumberFormat("ko-KR").format(price);
    }
    if (currencyCode === "TWD" || currencyCode === "NTD") {
      return (
        "NT$" +
        Intl.NumberFormat("zh-TW", { minimumFractionDigits: 2 }).format(price)
      );
    }
    if (currencyCode === "THB") {
      return (
        "฿" +
        Intl.NumberFormat("th-TH", { minimumFractionDigits: 2 }).format(price)
      );
    }
    if (currencyCode === "IDR") {
      return (
        "Rp" +
        Intl.NumberFormat("id-ID", { minimumFractionDigits: 2 }).format(price)
      );
    }
    if (currencyCode === "BRL") {
      return (
        "R$" +
        Intl.NumberFormat("pt-BR", { minimumFractionDigits: 2 }).format(price)
      );
    }
    return String(currencyCode + " " + price);
  }
})();
